// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"100":"password-recovery","727":"login-widget","966":"login"}[chunkId] + "." + {"100":"7a425c38","727":"f7176d61","966":"f7176d61"}[chunkId] + ".chunk.css";
};